import React from 'react';
import { Link } from 'react-router-dom';

import Typography from 'kingpin/atoms/Typography';
import ListItemWrapper from '../../../DatasetDefinitions/ListItemWrapper';
import Column from '../../../DatasetDefinitions/Column';
import { buildShowGlobalGoal } from '../../../../../navigation/appRoutes';
import Card from '../../../../../components/Common/Card';
import FindAndReplaceCheckbox from '../../MetricContextMenu/FindAndReplace/FindAndReplaceCheckbox';

const GoalsUsage = ({
  goals,
  usedId,
}: {
  goals: GeneralGoal[];
  usedId: string;
}) => (
  <>
    {goals.length > 0 && (
      <div style={{ marginBottom: 24 }}>
        <div style={{ marginBottom: '8px' }}>
          <Typography.Header type="H5">{`Goals (${goals.length})`}</Typography.Header>
        </div>
        <Card>
          {goals.map((g, index) => (
            <ListItemWrapper
              key={`${g.id}-${usedId}`}
              isLast={goals.length - 1 === index}
            >
              <FindAndReplaceCheckbox
                item={{ type: 'goals', goal: g, itemId: g.id }}
              />
              <Column
                style={{
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                }}
              >
                <Link
                  to={buildShowGlobalGoal(g.id)}
                  target="_blank"
                  style={{ display: 'flex' }}
                >
                  <Typography.Body type="Body 12" color="var(--color-info-v2)">
                    {g.title}
                  </Typography.Body>
                </Link>
              </Column>
            </ListItemWrapper>
          ))}
        </Card>
      </div>
    )}
  </>
);

export default GoalsUsage;
